import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import ScrollToTop from './components/ScrollToTop';
import { Navigate } from 'react-router-dom';
// ========================================
// ✅ HOME PAGE (All in Home_Page_WLog folder)
// ========================================
import Home_Page_WLog from "./Home_Page_WLog/Home_Page_WLog";
import LoginHeader from "./Home_Page_WLog/LoginHeader/LoginHeader";
import AllProfiles from "./Home_Page_WLog/AllProfiles/AllProfiles";

// ========================================
// LEGAL & FOOTER
// ========================================
import Contact from "./Home_Page_WLog/Contact_Us/Contact";
import Froud_Alert from "./Legal/Com_Details/Froud_Alert";
import Privacy_Features from "./Legal/Com_Details/Privacy_Features";
import Privacy_Policy from "./Legal/Com_Details/Privacy_Policy";
import Term_Use from "./Legal/Com_Details/Term_Use";
import PublicPromotions from "./Home_Page_WLog/components/Promotions/Promotions";

// ========================================
// AUTHENTICATION
// ========================================
import Login from "./Authentication/Login/Login";
import AdminLogin from "./Authentication/Login/AdminLogin";
import User_Reg from "./Authentication/Registration/Registration";
import User_Reg_WO from "./Authentication/Registration/Registration_WO"
import ResetPassword from './components/ResetPassword/ResetPassword';

// ========================================
// ADMIN PANEL
// ========================================
import AdminLayout from "./Panel/Admin_Panel/Layout/AdminLayout";
import Admin_Panel from "./Panel/Admin_Panel/Pages/Dashboard/Admin_Panel";
import User_Tables from "./Panel/Admin_Panel/Pages/UserManagement/User_Tables";
import Staff_Tables from "./Panel/Admin_Panel/Pages/StaffManagement/Staff_Tables";
import Transactions from "./Panel/Admin_Panel/Pages/Transactions/Transactions";
import Withdrawals from "./Panel/Admin_Panel/Pages/Withdrawals/Withdrawals";
import ContactEnquiries from "./Panel/Admin_Panel/Pages/ContactEnquiries/ContactEnquiries";
import PostCommission from "./Panel/Admin_Panel/Pages/PostCommission/PostCommission";
import PremiumMembers from "./Panel/Admin_Panel/Pages/PremiumMembers/PremiumMembers";
import AddPremiumPlan from "./Panel/Admin_Panel/Pages/PremiumMembers/AddPremiumPlan";
import Reports from "./Panel/Admin_Panel/Pages/Reports/Reports";
import Banners from "./Panel/Admin_Panel/Pages/Banners/Banners";
import SettingsAdmin from "./Panel/Admin_Panel/Pages/Settings/Settings";
import AdminUsers from "./Panel/Admin_Panel/Pages/AdminUsers/AdminUsers";
import ASuccessStories from "./Panel/Admin_Panel/Pages/SuccessStories/SuccessStories";
import Promotions from "./Panel/Admin_Panel/Pages/Promotions/Promotions";
import ReligionSettings from "./Panel/Admin_Panel/Pages/Settings/ReligionSettings";
import AdminWallet from "./Panel/Admin_Panel/Pages/AdminWallet/AdminWallet"

// ========================================
// STAFF PANEL
// ========================================
import StaffLayout from "./Panel/Staff_Panel/Layout/StaffLayout";
import StaffDashboard from "./Panel/Staff_Panel/Pages/Dashboard/StaffDashboard";
import StaffUsers from "./Panel/Staff_Panel/Pages/Users/StaffUsers";
import StaffTransactionsPage from "./Panel/Staff_Panel/Pages/Transactions/StaffTransactions";
import StaffBankDetails from "./Panel/Staff_Panel/Pages/StaffBank/StaffBankDetails";
import StaffWithdrawals from "./Panel/Staff_Panel/Pages/Withdrawals/StaffWithdrawals";
import SSuccessStories from "./Panel/Staff_Panel/SuccessStories/SuccessStories";
import StaffPremiumMembers from "./Panel/Staff_Panel/Pages/StaffPremiumMembers/StaffPremiumMembers";
import StaffRegister from "./Panel/Staff_Panel/Pages/StaffRegister/StaffRegister";
import StaffAuth from "./Panel/Staff_Panel/Pages/StaffAuth/StaffAuth";

// ========================================
// USER PANEL
// ========================================
import User_Panel from "./Panel/User_Panel/User_Panel";
import User_Added_User from "./Panel/User_Panel/User_Added_User";
import User_Transaction_User from "./Panel/User_Panel/User_Transaction_User";
import User_Withdrawal_User from "./Panel/User_Panel/User_Withdrawal_User";
import User_Profile_User from "./Panel/User_Panel/User_Profile_User";
import User_Recharge from "./Panel/User_Panel/User_Recharge";
import User_Apply from "./Panel/User_Panel/User_Apply";
import User_Home from "./Panel/User_Panel/user_home";
import User_Bank_Details from "./Panel/User_Panel/User_Bank_Details";
import User_Auto_Match_User from "./Panel/User_Panel/User_Auto_Match_User";


// ========================================
// DEV PANEL
// ========================================\

import DeveloperBankDetails from './Panel/Admin_Panel/Pages/DeveloperBankDetails/DeveloperBankDetails'
import DeveloperWithdrawal from './Panel/Admin_Panel/Pages/DeveloperWithdrawal/DeveloperWithdrawal'


// ========================================
// USER DASHBOARD
// ========================================
import Layout from './Userdashboard/layout/Layout';
import Dashboard from './Userdashboard/pages/Dashboard';
import BiodataMatches from './Userdashboard/pages/BiodataMatches';
import Shortlisted from './Userdashboard/pages/Shortlisted';
import Messages from './Userdashboard/pages/Messages';
import Requests from './Userdashboard/pages/Requests';
import Visitors from './Userdashboard/pages/Visitors';
import Recharge from './Userdashboard/pages/Recharge';
import Profile from './Userdashboard/pages/Profile';
import Settings from './Userdashboard/pages/Settings';
import AllUsers from "./Userdashboard/pages/AllUsers";
import UserProfileView from "./Userdashboard/pages/UserProfileView";
import PaymentStatus from "./Userdashboard/pages/PaymentStatus";
import Notifications from './Userdashboard/pages/Notifications';
import USuccessStories from "./Userdashboard/pages/SuccessStories";
import MyReferrals from './Userdashboard/pages/MyReferrals';

import BankDetails from "./Userdashboard/pages/BankDetails";
import Withdraw from "./Userdashboard/pages/Withdraw";

import Test from "./Test";

// ========================================
// COMING SOON PLACEHOLDER
// ========================================
const ComingSoon = ({ title }) => (
  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    background: "#fff",
    borderRadius: "12px",
    padding: "40px",
    margin: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
  }}>
    <div style={{ fontSize: "64px", marginBottom: "16px" }}>🚧</div>
    <h2 style={{ color: "#1890ff", fontSize: "24px", margin: "0 0 8px 0" }}>
      {title}
    </h2>
    <p style={{ color: "#8c8c8c", margin: 0 }}>Coming Soon...</p>
  </div>
);

// ========================================
// APP COMPONENT
// ========================================
function App() {
  const ProtectedUserRoute = ({ children }) => {
    const token = localStorage.getItem('access_token');
    const role = localStorage.getItem('role');

    if (!token) {
      return <Navigate to="/login" replace />;
    }

    if (role && role !== 'user') {
      if (role === 'admin' || role === 'superadmin' || role === 'developer') {
        return <Navigate to="/Admin_Panel" replace />;
      }
      if (role === 'staff') {
        return <Navigate to="/Staff_Panel" replace />;
      }
      return <Navigate to="/login" replace />;
    }

    return children;
  };
  const PrivateRoute = ({ children }) => {
  const userId = localStorage.getItem("user_id");
  const token = localStorage.getItem("access_token");

  if (!userId || !token) {
    return <Navigate to="/User_Login" replace />;
  }
  return children;
};
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>

        {/* ==========================================
            ✅ HOME PAGE (Main Landing)
            ========================================== */}
        <Route path="/" element={<Home_Page_WLog />} />
        <Route path="/Home_Page_WLog" element={<Home_Page_WLog />} />
        <Route path="/home" element={<Home_Page_WLog />} />

        {/* ✅ All Profiles */}
        <Route
  path="/all-profiles"
  element={
    <PrivateRoute>
      <AllProfiles />
    </PrivateRoute>
  }
/>

        {/* LEGAL */}
        <Route path="/Froud_Alert" element={<Froud_Alert />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Privacy_Features" element={<Privacy_Features />} />
        <Route path="/Privacy_Policy" element={<Privacy_Policy />} />
        <Route path="/Term_Use" element={<Term_Use />} />
        <Route path="/services" element={<PublicPromotions />} />

        {/* LOGIN */}
        <Route path="/login" element={<Login />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/User_Login" element={<Login />} />
        <Route path="/Admin_Login" element={<AdminLogin />} />
        {/* <Route path="/Staff_Login" element={<Login />} /> */}
        <Route path="/Dev_Login" element={<AdminLogin />} />
        <Route path="/reset-password/:uid/:token/" element={<ResetPassword />} />
        <Route path="/staff_login" element={<StaffAuth />} />

        {/* REGISTRATION */}

        <Route path="/User_Reg" element={<User_Reg />} />
        <Route path="/User_Reg/:id" element={<User_Reg />} />
        <Route path="/User_Reg_WO" element={<User_Reg_WO />} />



        {/* ==========================================
            ADMIN PANEL
            ========================================== */}
        <Route element={<AdminLayout />}>
          <Route path="/Admin_Panel" element={<Admin_Panel />} />
          <Route path="/admin/users" element={<User_Tables />} />
          <Route path="/admin/users/:id" element={<ComingSoon title="User Details" />} />
          <Route path="/admin/staff" element={<Staff_Tables />} />
          <Route path="/admin/staff/:id" element={<ComingSoon title="Staff Details" />} />
          <Route path="/admin/transactions" element={<Transactions />} />
          <Route path="/admin/withdrawals" element={<Withdrawals />} />
          <Route path="/admin/contactenquiries" element={<ContactEnquiries />} />
          <Route path="/admin/commission" element={<PostCommission />} />
          <Route path="/admin/success-stories" element={<ASuccessStories />} />
          <Route path="/premium-members" element={<PremiumMembers />} />
          <Route path="/admin/add-premium-plan" element={<AddPremiumPlan />} />
          <Route path="/admin/promotions" element={<Promotions />} />
          <Route path="/admin/add-promotion" element={<Promotions />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/banners" element={<Banners />} />
          <Route path="/pages" element={<ComingSoon title="Pages Management" />} />
          <Route path="/settings-admin" element={<SettingsAdmin />} />
          <Route path="/admin-users" element={<AdminUsers />} />
          <Route path="/admin/religion-settings" element={<ReligionSettings />} />
          <Route path="/admin/wallet" element={<AdminWallet />} />


          {/* Developer PANEL */}
          <Route path="/developer/bank-details" element={<DeveloperBankDetails />} />
          <Route path="/developer/withdrawals" element={<DeveloperWithdrawal />} />
        </Route>

       

        {/* STAFF PANEL */}
        <Route element={<StaffLayout />}>
          <Route path="/Staff_Panel" element={<StaffDashboard />} />
          <Route path="/staff/users" element={<StaffUsers />} />
          <Route path="/staff/transactions" element={<StaffTransactionsPage />} />
          <Route path="/staff/bank" element={<StaffBankDetails />} />
          <Route path="/staff/withdrawals" element={<StaffWithdrawals />} />
          <Route path="/staff/success-stories" element={<SSuccessStories />} />
          <Route path="/staff/premium-members" element={<StaffPremiumMembers />} />
          <Route path="/staff-register" element={<StaffRegister />} />
          
        </Route>



        {/* USER PANEL */}
        <Route path="/User_Panel" element={<User_Panel />} />
        <Route path="/User_Added_User" element={<User_Added_User />} />
        <Route path="/User_Transaction_User" element={<User_Transaction_User />} />
        <Route path="/User_Withdrawal_User" element={<User_Withdrawal_User />} />
        <Route path="/User_Profile_User" element={<User_Profile_User />} />
        <Route path="/User_Recharge" element={<User_Recharge />} />
        <Route path="/User_Apply" element={<User_Apply />} />
        <Route path="/User_Home" element={<User_Home />} />
        <Route path="/User_Bank_Details" element={<User_Bank_Details />} />
        <Route path="/User_Auto_Match_User" element={<User_Auto_Match_User />} />
        <Route path="/Test" element={<Test />} />

        {/* USER DASHBOARD */}
        <Route element={<ProtectedUserRoute>
          <Layout />
        </ProtectedUserRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/biodata" element={<BiodataMatches />} />
          <Route path="/shortlisted" element={<Shortlisted />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/requests" element={<Requests />} />
          <Route path="/visitors" element={<Visitors />} />
          <Route path="/recharge" element={<Recharge />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/bank-details" element={<BankDetails />} />
          <Route path="/wallet" element={<Withdraw />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/all-users" element={<AllUsers />} />
          <Route path="/user-profile/:userId" element={<UserProfileView />} />
          <Route path="/payment-status" element={<PaymentStatus />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/success-stories" element={<USuccessStories />} />
          <Route path="/my-referrals" element={<MyReferrals />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;